import React from "react";

export const CreditContext = React.createContext();
export const CreditDispatchContext = React.createContext();


function CreditProvider({children}) {
    const [state,setstate] = React.useState({balance:0})
    return(
        <CreditContext.Provider value={state}>
            <CreditDispatchContext.Provider value={setstate} >
                {children}
            </CreditDispatchContext.Provider>
        </CreditContext.Provider>
    )
}

export {CreditProvider};
